module.exports = __webpack_public_path__ + "media/games-19.5d9cc552.mp4";